export default "__VITE_ASSET__BGz6aI39__"